export default __webpack_public_path__ + "static/media/icons_arrow-right-white.fc432a0c.svg";